export default "__VITE_ASSET__ByTmUn5M__"